import CommentModel from './commentModel'
import SearchAreaStatusEnum from '../enums/searchAreaStatusEnum'

export default class SearchAreaModel {
    label !: string
    id !: string
    status: SearchAreaStatusEnum = SearchAreaStatusEnum.InProgress
    comments !: Array<CommentModel>

    constructor (comments: boolean = false) {
      if (comments) {
        this.comments = []
      }
    }

    set (input: any): SearchAreaModel {
      this.label = input.name
      this.id = input.id
      return this
    }
}
